<template>
  <div id="app">
    <component :is="navBarComponent" :key="navBarKey" />
    <div class="main container">
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import NavBarForSales from '@/components/NavBarForSales.vue';
import NavBarForWriting from "@/components/NavBarForWriting.vue";

export default {
  components: {
    NavBar,
    NavBarForSales,
    NavBarForWriting,
  },
  data() {
    return {
      navBarComponent: 'NavBar', // 文字列として指定
      navBarKey: 0 // 強制再レンダリング用
    };
  },
  watch: {
    $route(to) {
      // ルーターのパスに応じてナビゲーションバーを変更
      if (to.path.startsWith('/forsales')) {
        this.navBarComponent = 'NavBarForSales';
      }
      else if (to.path.startsWith('/forwriting')) {
        this.navBarComponent = 'NavBarForWriting';
      }
      else {
        this.navBarComponent = 'NavBar';
      }
      
      // コンポーネントが変更されたときに強制再レンダリング
      this.navBarKey++;
    },
    
    // ストアの認証状態を監視
    '$store.getters.isAuthenticated'(newVal, oldVal) {
      console.log('Authentication state changed:', oldVal, '->', newVal);
      // 認証状態が変わったときに強制再レンダリング
      this.navBarKey++;
    }
  },
  
  async mounted() {
    console.log('🔍 [APP] App.vue mounted, current route:', this.$route.path);
    console.log('🔍 [APP] Current auth state:', {
      isAuthenticated: this.$store.getters.isAuthenticated,
      user: this.$store.getters.stateUser
    });
    
    // 認証不要なページかどうかをチェック
    let requiresAuth = false;
    
    for (let i = this.$route.matched.length - 1; i >= 0; i--) {
      const record = this.$route.matched[i];
      
      // 明示的に認証不要が設定されている場合はfalse
      if (record.meta.requiresAuth === false) {
        requiresAuth = false;
        break;
      }
      // 明示的に認証必要が設定されている場合はtrue
      if (record.meta.requiresAuth === true) {
        requiresAuth = true;
        break;
      }
      // デフォルトは親ルートの設定に従う
      if (record.meta.requireAuth === true) {
        requiresAuth = true;
      }
    }
    
    console.log('🔍 [APP] Auth requirement check:', {
      requiresAuth,
      routePath: this.$route.path,
      matched: this.$route.matched.map(record => ({
        path: record.path,
        name: record.name,
        meta: record.meta
      }))
    });
    
    // ローカルストレージから認証状態が復元されている場合でも、
    // サーバーで認証状態を確認する
    if (this.$store.getters.isAuthenticated) {
      console.log('🔍 [APP] User found in localStorage, validating with server...');
      try {
        if (this.$route.path.startsWith('/forwriting')) {
          await this.$store.dispatch("viewMe_forwriting");
        } else {
          await this.$store.dispatch("viewMe");
        }
        console.log('✅ [APP] Server authentication validation successful');
      } catch (error) {
        console.error('❌ [APP] Server authentication validation failed:', error);
        // サーバー認証失敗時は、認証が必要なページの場合のみログアウト
        if (requiresAuth) {
          console.log('🔄 [APP] Clearing invalid authentication state');
          await this.$store.dispatch('logOut');
        }
      }
    } else if (requiresAuth) {
      console.log('🔍 [APP] Auth required but no user found, checking with server...');
      try {
        if (this.$route.path.startsWith('/forwriting')) {
          await this.$store.dispatch("viewMe_forwriting");
        } else {
          await this.$store.dispatch("viewMe");
        }
        console.log('✅ [APP] Server authentication check successful');
      } catch (error) {
        console.error('❌ [APP] Server authentication check failed:', error);
      }
    } else {
      console.log('ℹ️ [APP] Auth not required, skipping authentication check');
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Noto+Sans+TC:wght@400;500;700&display=swap");

:root {
  --app-font-stack: "Noto Sans TC", "PingFang TC", "Microsoft JhengHei",
    "Heiti TC", Arial, "M PLUS Rounded 1c", Helvetica, sans-serif;
}

html[lang="ja"] {
  --app-font-stack: Avenir, Helvetica, Arial, sans-serif;
}

#app {
  font-family: var(--app-font-stack);
  color: #2c3e50;
}

body,
button,
input,
select,
li,
textarea,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--app-font-stack);
}

.main {
  padding-top: 4.5rem;
}

body {
  margin: 0;
  padding: 0;
}

button {
  border: none;
  background-color: black;
  color: rgb(233, 233, 233);
  padding: 0 20px;
}
</style>
